import styled from "styled-components";
import ButtonCSS from "./Button.css";

const StyledButton = styled.button`
  ${ButtonCSS}
`
export default StyledButton;